
export default {
  name: 'TheProgram',
  props: {
    specializationsList: {
      type: Object,
      required: true
    },

    selectedBlock: {
      type: Object,
      required: true
    },

    refreshTab: {
      type: Function,
      required: true
    },

    isHideCompleted: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    isStreamList() {
      return !!this.selectedBlock?.streamListsForChange?.length
    },

    programBlocks() {
      return this.selectedBlock.tabs || []
    }
  }
}
